import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import ContentLoading from '../../../components/ContentLoading';
import WorkspaceSelector from '../../views/WorkspaceSelector';
import ContentError from '../../../components/ContentError';

/**
 * Responsible for making the user pick a workspace, or use the one loaded for the domain.
 */
var WorkspaceGateway = observer(_class = /*#__PURE__*/function (_React$Component) {
  function WorkspaceGateway() {
    _classCallCheck(this, WorkspaceGateway);
    return _callSuper(this, WorkspaceGateway, arguments);
  }
  _inherits(WorkspaceGateway, _React$Component);
  return _createClass(WorkspaceGateway, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.rootStore.workspaceSelectorStore.initializeFromEnvironment(this.props.invitationToken, this.props.workspaceSlug);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var rootStore = this.props.rootStore;
      var sessionStore = rootStore.sessionStore;
      var workspaceSelectorStore = rootStore.workspaceSelectorStore;
      return workspaceSelectorStore.initializeFromEnvironment.match({
        pending: function pending() {
          return /*#__PURE__*/React.createElement(ContentLoading, null);
        },
        rejected: function rejected(err) {
          return /*#__PURE__*/React.createElement(ContentError, {
            error: err
          });
        },
        resolved: function resolved() {
          return (
            // Render the selector either if no workspace is selected, or if the workspace member has not been created
            // for the logged in user.
            workspaceSelectorStore.canCloseSelector && !workspaceSelectorStore.showing ? _this.props.children(sessionStore.workspace) : /*#__PURE__*/React.createElement(WorkspaceSelector, {
              rootStore: rootStore,
              invitationToken: _this.props.invitationToken
            })
          );
        }
      });
    }
  }]);
}(React.Component)) || _class;
export { WorkspaceGateway as default };
//# sourceMappingURL=index.js.map
